"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ClientCultureProvider = require("./ClientCultureProvider");
Object.keys(_ClientCultureProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ClientCultureProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ClientCultureProvider[key];
    }
  });
});
var _FormatBp = require("./FormatBp");
Object.keys(_FormatBp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormatBp[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormatBp[key];
    }
  });
});
var _FormatCurrency = require("./FormatCurrency");
Object.keys(_FormatCurrency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormatCurrency[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormatCurrency[key];
    }
  });
});
var _FormatDate = require("./FormatDate");
Object.keys(_FormatDate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormatDate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormatDate[key];
    }
  });
});
var _FormatNumber = require("./FormatNumber");
Object.keys(_FormatNumber).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormatNumber[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormatNumber[key];
    }
  });
});
var _FormatPercent = require("./FormatPercent");
Object.keys(_FormatPercent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormatPercent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormatPercent[key];
    }
  });
});
var _FormatPoints = require("./FormatPoints");
Object.keys(_FormatPoints).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormatPoints[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormatPoints[key];
    }
  });
});
var _ServerCultureProvider = require("./ServerCultureProvider");
Object.keys(_ServerCultureProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ServerCultureProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ServerCultureProvider[key];
    }
  });
});
//# sourceMappingURL=index.js.map